import { FC } from 'react';
import ModalityCard, {
  CardType,
} from 'react-components/modalities/modality-card/modality-card';
import styles from './cards.module.scss';

type Props = {
  action: () => void;
  analyticsEvent?: () => void;
  shouldGrow?: boolean;
};
import Button from 'wa-storybook/components/general/button/button';

const ScheduleAppointmentCard: FC<Props> = ({
  action,
  analyticsEvent,
  shouldGrow,
}: Props) => {
  return (
    <ModalityCard
      type={CardType.primary}
      title={polyglot.t('online_booking.modalities.speak_to_counsellor.title')}
      info={polyglot.t('online_booking.modalities.speak_to_counsellor.info')}
      shouldGrow={shouldGrow}
    >
      <div className={styles['btn-container']}>
        <Button
          text={polyglot.t('online_booking.modalities.speak_to_counsellor.cta')}
          onClick={() => {
            if (analyticsEvent) {
              analyticsEvent();
            }

            action();
          }}
          theme='contained--on-primary'
        />
      </div>
    </ModalityCard>
  );
};

export default ScheduleAppointmentCard;
